
import { Mixins } from 'vue-property-decorator'
import { SwitchTableMixin } from './switch-table-mixin'
import DSwitchTableItem from './d-switch-table-item.vue'
import { Options } from 'vue-class-component'
import { EventBuss } from '@/utils/constants'

@Options({
    components: {
        DSwitchTableItem
    }
})
export default class MobileSwitchTableView extends Mixins(SwitchTableMixin) {
    scrollReloadTimer: number | boolean = false

    onListScroll(): void {
        if (typeof this.scrollReloadTimer === 'number') {
            clearTimeout(this.scrollReloadTimer)
        }

        this.scrollReloadTimer = window.setTimeout(() => {
            this.scrollReloadTimer = false
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            this.emitter.emit(EventBuss.RELOAD_MAP)
        }, 150)
    }

    beforeUnmount(): void {
        if (typeof this.scrollReloadTimer === 'number') {
            clearTimeout(this.scrollReloadTimer)
            this.scrollReloadTimer = false
        }
    }
}
